<template>
  <SplashWrapper hide-buttons>
    <iRow align="center">
      <iColumn :width="1200">
        <iHeading>USER & VISITOR COOKIE POLICY</iHeading>
        <iSpace />
        <iText overflow>
          This User & Visitor Cookie Policy explains how we use cookies and similar technologies on our platform.
        </iText>

        <iSubHeading>1. What are Cookies?</iSubHeading>
        <iText overflow>
          Cookies are small pieces of data stored on your device when you visit our website or use our services.
          They help us recognize your device, preferences, and enhance your browsing experience.
        </iText>

        <iSpace />

        <iSubHeading>1. Types of Cookies We Use</iSubHeading>
        <iText overflow>
          Cookies are small pieces of data stored on your device when you visit our website or use our services.
          They help us recognize your device, preferences, and enhance your browsing experience.
        </iText>

        <ol type="a">
          <iText overflow>
            <li>
              <strong>Necessary Cookies</strong>:
              These cookies are essential for the proper functioning of our website and services.
              They enable basic features and are necessary for you to navigate our site.
            </li>
          </iText>
          <iText overflow>
            <li>
              <strong>Preference Cookies</strong>:
              These cookies allow us to remember your preferences and settings to provide a more personalized experience.
            </li>
          </iText>
          <iText overflow>
            <li>
              <strong>Analytics Cookies</strong>:
              We use analytics cookies to collect information about how users interact with our website.
              This helps us improve our services and understand user behavior.
            </li>
          </iText>
          <iText overflow>
            <li>
              <strong>Marketing Cookies</strong>:
              Marketing cookies are used to track your online activities and tailor advertising content to your interests.
            </li>
          </iText>
        </ol>

        <iSpace />

        <iSubHeading>3. Third-Party Cookies</iSubHeading>
        <iText overflow>
          We may also allow third-party service providers to use cookies on our site.
          These cookies are subject to the respective third parties' privacy policies and may collect information for their own purposes.
        </iText>

        <iSpace />

        <iSubHeading>4. Cookie Consent</iSubHeading>

        <iText overflow>
          By using our website or services, you consent to the use of cookies in accordance with this policy.
          You can manage or delete cookies through your browser settings.
        </iText>

        <iSpace />

        <iSubHeading>5. Opting Out</iSubHeading>

        <iText overflow>
          You have the option to control and manage cookie preferences.
          Most web browsers allow you to block or delete cookies, but this may impact your experience on our site.
        </iText>

        <iSpace />

        <iSubHeading>6. Updates to Policy</iSubHeading>

        <iText overflow>
          We may update this Cookies Policy to reflect changes in technology or legal requirements.
          We encourage you to review this policy regularly for any updates.
        </iText>
        <iText overflow>
          By continuing to use our platform, you consent to the use of cookies as described in this policy.
        </iText>
      </iColumn>
    </iRow>
    <iSpace :height="20" />
  </SplashWrapper>
</template>

<script>
import SplashWrapper from "@/components/splash/SplashWrapper.vue";

export default {
  name: "CookiePolicy",
  components: { SplashWrapper },
};
</script>

<style scoped lang="scss">
.nav-container {
  position: sticky;
  background-color: white;
  top: 0;
  z-index: 1;
}
.nav-bar {
  width: 100%;
  padding: 0 40px;
}
</style>
